export default __webpack_public_path__ + "static/media/gov_arknote@2x.5cb08f97.png";